import {
  SECONDARY_PRODUCT,
  PRODUCT,
  APPLICATION,
  PRODUCT_DOMAIN,
} from "@/constants";
import { BrandKey, Product } from "@/types/common-types";

let brand: BrandKey | Product;
if (SECONDARY_PRODUCT === "expat") {
  brand = "expat";
} else if (PRODUCT_DOMAIN === "IRE") {
  brand = "ireland";
} else if (PRODUCT_DOMAIN === "ESP") {
  brand = "spain";
} else {
  brand = (PRODUCT as "staysure" | "avanti") ?? "staysure";
}

export const fontVerisk: Record<
  BrandKey | Product,
  { primaryFont: string; secondoryFont: string }
> = {
  avanti: {
    primaryFont: '"faktum", "Helvetica", "Arial", "sans-serif"',
    secondoryFont: '"faktum", "sans-serif"',
  },
  staysure: {
    primaryFont: '"proxima-nova", "Helvetica", "Arial", "sans-serif"',
    secondoryFont: '"DM Serif Display", "sans-serif"',
  },
  expat: {
    primaryFont: '"proxima-nova", "Helvetica", "Arial", "sans-serif"',
    secondoryFont: '"DM Serif Display", "sans-serif"',
  },
  ireland: {
    primaryFont: '"proxima-nova", "Helvetica", "Arial", "sans-serif"',
    secondoryFont: '"DM Serif Display", "sans-serif"',
  },
  spain: {
    primaryFont: '"proxima-nova", "Helvetica", "Arial", "sans-serif"',
    secondoryFont: '"DM Serif Display", "sans-serif"',
  },
};

export const styleVerisk: Record<
  BrandKey | Product,
  { showStyleInitiate: boolean; stylesheet: string; herf: string; id: string }
> = {
  avanti: {
    showStyleInitiate: true,
    stylesheet: "stylesheet",
    herf: "/avanti.css",
    id: "brand-stylesheet-avanti",
  },
  staysure: {
    showStyleInitiate: true,
    stylesheet: "stylesheet",
    herf: "/staysure.css",
    id: "brand-stylesheet-staysure",
  },

  expat: {
    showStyleInitiate: true,
    stylesheet: "stylesheet",
    herf: "/staysure.css",
    id: "brand-stylesheet-staysure",
  },
  ireland: {
    showStyleInitiate: true,
    stylesheet: "stylesheet",
    herf: "/staysure.css",
    id: "brand-stylesheet-staysure",
  },
  spain: {
    showStyleInitiate: true,
    stylesheet: "stylesheet",
    herf: "/staysure.css",
    id: "brand-stylesheet-staysure",
  },
};

export const brandVerisk: Record<Product, { v3: string; domain: string }> = {
  avanti: {
    v3: "avt",
    domain: "AVN",
  },
  staysure: {
    v3: "sts",
    domain: "STS",
  },
  expat: {
    v3: "exp",
    domain: "EXP",
  },
  ireland: {
    v3: "sts",
    domain: "IRE",
  },
  spain: {
    v3: "sts",
    domain: "ESP",
  },
};

export function isMedicalDrawerEnable(): boolean {
  let enableDrawer = true;

  if (APPLICATION === "renewal") {
    enableDrawer = false;
  }
  return enableDrawer;
}
export const brandVeriskForMedicalScreening = brandVerisk[brand];
export const styleVeriskForMedicalScreening = styleVerisk[brand as BrandKey];
export const fontVeriskForMedicalScreening = fontVerisk[brand as BrandKey];
